import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private hubConnection: any;
  private paymentStatusSubject = new Subject<any>();
  paymentStatus$ = this.paymentStatusSubject.asObservable();
  customerID!: string;

  constructor(private authenticationService: AuthenticationService) {
    const user = this.authenticationService.getUser();
    if (!user?.CustomerId) return;
    this.customerID = user.CustomerId;
    this.startConnection(this.customerID);
  }

  private startConnection(customerId: string) {
    this.hubConnection = $.hubConnection(`${environment.FT_SHOP_API_URL}/signalr`);
    const hubProxy = this.hubConnection.createHubProxy('NotificationHub');

    hubProxy.on('paymentStatusUpdated', (orderId: string, status: string, customerId: string) => {
      this.paymentStatusSubject.next({ orderId, status, customerId });
    });

    this.hubConnection.start()
      .done(() => {
        console.log('✅ Connected to SignalR');
        hubProxy.invoke('JoinCustomerGroup', customerId);
      })
      .fail((err: any) => console.error('❌ SignalR connection error:', err));
  }
}
